import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { DemonstrativoQuitacaoService } from '../../../services/demonstrativo-quitacao.servie';
import { DemonstrativoQuitacao } from '../../models/demonstrativo-quitacao.model';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './banner.html',
  styleUrls: ['./banner.scss']
})
export class Banner {

  constructor(private DemonstrativoQuitacaoService: DemonstrativoQuitacaoService) {}

  /** Id do cliente */
  @Input() dados: DemonstrativoQuitacao = new DemonstrativoQuitacao();

 
  /** Ação do botão (deixa o componente desacoplado do backend) */
  @Output() baixar = new EventEmitter<DemonstrativoQuitacao>();


  onBaixar(): void {
    this.DemonstrativoQuitacaoService.baixarDemonstrativo(this.dados).subscribe({
      next: (htmlRaw: string) => {
        const win = window.open('', '_blank');
        if (!win) return;

        win.document.open();
        win.document.write(htmlRaw);
        win.document.close();

        win.print();
      },
      error: (error) => console.error('Erro ao gerar demonstrativo:', error)
    });

    this.baixar.emit(this.dados);
  }
}
